import { palette, spacing } from '$tablet-app/src/app/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { FC } from 'react';
import {
  ModalProps,
  StyleProp,
  StyleSheet,
  View,
  ViewStyle,
} from 'react-native';
import NewButton from '../Button/NewButton';
import Dialog from '../Dialog';
import { Text } from '../Text/Text';

export interface DeleteModalProps extends ModalProps {
  visible?: boolean;
  onCancel: () => void;
  style?: StyleProp<ViewStyle>;
  title: string;
  subtitle: string;
}

const DeleteModal: FC<DeleteModalProps> = ({
  visible,
  onCancel,
  title,
  subtitle,
  ...rest
}) => {
  return (
    <Dialog size="sm" visible={visible} {...rest}>
      <View style={styles.container}>
        <View style={styles.topButtons}>
          <NewButton variant="secondary" onPress={onCancel} icon="times" />
        </View>

        <View style={styles.imageWrap}>
          <FontAwesomeIcon size={50} icon="trash" color={palette.white} />
        </View>

        <View style={styles.textWrapper}>
          <Text style={styles.heading}>{title}</Text>
          <Text style={styles.desc}>{subtitle}</Text>
        </View>

        {rest.children}
        <NewButton
          onPress={onCancel}
          style={styles.buttons}
          variant="secondary"
        >
          Cancel
        </NewButton>
      </View>
    </Dialog>
  );
};

// Styles
const styles = StyleSheet.create({
  buttons: {
    marginTop: 20,
    width: '100%',
  },
  closeButton: {
    marginLeft: spacing[4],
    paddingHorizontal: spacing[4],
  },
  container: {
    alignItems: 'center',
    padding: 16,
  },
  desc: {
    fontSize: 18,
  },
  heading: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: spacing[4],
  },
  imageWrap: {
    alignItems: 'center',
    backgroundColor: palette.Red,
    borderRadius: 58,
    height: 116,
    justifyContent: 'center',
    width: 116,
  },
  textWrapper: {
    alignItems: 'center',
    marginBottom: spacing[5],
    marginTop: 56,
  },
  topButtons: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
  },
});

export default DeleteModal;
